import { useRef } from "react";
import { joinMessage, playCardsMessage, passMessage } from "../utilities/protocol";

const WS_URL = "ws://localhost:9090/ws/paoyao";
// const WS_URL = "wss://paoyao.zhaojunan.com/ws/paoyao";

export function useGameSocket(handlers: {
    onJoined: (playerId: string) => void;
    onPlayerList: (players: any[]) => void;
    onGameStart: () => void;
    onDealCards: (cards: string[]) => void;
    onGameState: (state: any) => void;
    onHandUpdate: (cards: string[]) => void;
    onError: (message: string) => void;
    onRoundEnd: (payload: { winnerId: string; winnerName: string; teamScores: Record<string, number> }) => void;
    onGameEnd: (payload: { winningTeam: number; teamScores: Record<string, number>; winReason: string }) => void;
}) {
    const wsRef = useRef<WebSocket | null>(null);

    const connect = (name: string) => {
        const ws = new WebSocket(WS_URL);
        wsRef.current = ws;

        ws.onopen = () => {
            ws.send(JSON.stringify(joinMessage(name)));
        };

        ws.onmessage = (msg) => {
            const data = JSON.parse(msg.data);

            switch (data.type) {
                case "joined":
                    handlers.onJoined(data.payload.playerId);
                    break;
                case "player_list":
                    handlers.onPlayerList(data.payload);
                    break;
                case "game_start":
                    handlers.onGameStart();
                    break;
                case "deal_cards":
                    handlers.onDealCards(data.payload.cards);
                    break;
                case "hand_update":
                    handlers.onHandUpdate(data.payload.cards);
                    break;
                case "game_state":
                    console.log("game_state: ", data.payload);
                    handlers.onGameState(data.payload);
                    break;
                case "error":
                    handlers.onError(data.payload);
                    break;
                case "round_end":
                    handlers.onRoundEnd(data.payload);
                    break;
                case "game_end":                          // <-- new
                    handlers.onGameEnd(data.payload);
                    break;
            }
        };

        ws.onclose = (event) => {
            console.log("WebSocket closed:", event.code, event.reason);
        };

        ws.onerror = (err) => {
            console.error("WebSocket error:", err);
        };
    };

    const playCards = (cards: string[]) => {
        if (!wsRef.current) return;

        if (wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify(playCardsMessage(cards)));
        } else {
            console.error("WebSocket is not open. Current state:", wsRef.current.readyState);
        }
    };

    const pass = () => {
        if (!wsRef.current) return;

        if (wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify(passMessage()));
        } else {
            console.error("WebSocket is not open. Current state:", wsRef.current.readyState);
        }
    };

    return { connect, playCards, pass };
}